<section class="otp-wrapper">
  <article>
    <h1>Verificação de Segurança</h1>
    <p>
      Para realizar a renovação, informe os {{ MAX_OTP_LENGTH }} primeiros dígitos do CPF do
      <strong>titular</strong>:
    </p>

    <form novalidate (submit)="save($event)">
      <h2>Insira os 5 primeiros números do CPF</h2>

      <ng-otp-input
        [formControl]="otpControl"
        (onInputChange)="focusWhenFilled($event)"
        ngDefaultControl
        [config]="{
          length: MAX_OTP_LENGTH,
          allowNumbersOnly: true,
          inputClass: 'otp-wrapper__input',
        }"
      ></ng-otp-input>

      @if (otpControl.dirty && otpControl.errors; as error) {
        <div class="otp-wrapper__errors">
          @if (error?.["required"] || error?.["minlength"]) {
            <p>Informe os {{ MAX_OTP_LENGTH }} primeiros dígitos de um CPF válido</p>
          }

          @if (error?.["custom"]; as custom) {
            <p [innerHTML]="custom"></p>
          }
        </div>
      }

      <footer>
        <button
          #button
          type="submit"
          class="m-button-primary"
          [disabled]="otpControl.value?.length !== MAX_OTP_LENGTH"
        >
          Continuar
        </button>
      </footer>
    </form>
  </article>
</section>
